<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    div(v-else-if="orders.length > 0")
      .container(v-for="order in orders", :key="order.id")
        .row
          .col-6
            h4.mt-0.mb-0 {{ `Order #${order.id}` }}
            //span.pt-0 {{ order.type.toUpperCase() }}
            p.mb-0 {{order.created_pretty }}
            b-badge.mr-1(variant="") {{ order.type.toUpperCase() }}
            b-badge(variant="") {{ order.status.toUpperCase() }}
            p(v-if="order.status=='pending'") {{ `You have until ${order.valid_until} to complete this order` }}
          .col-6.text-right
            b-button.btn-outline(@click="openRow(order)") VIEW ORDER
        hr(v-if="orders.length > 1")
    nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Order',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      orders: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'id', label: 'Order', sortable: true },
        { key: 'created_pretty', label: 'Placed' },
        { key: 'compType', label: 'Type' },
        { key: 'compTotal', label: 'Total' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.orders.length;
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'order', params: { orderId: row.id } });
    },
  },
  async created() {
    this.loading();
    this.orders = await apiService.getOrders();
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AccountOrders.vue